import { createContext, useContext } from "react";
import { User } from "../common/models/User";
export interface AuthContextInterface {
  user: User | null;
  signin: (publicAddress: string,  successCallback: (user: User) => void, errorCallback: (errorMessage: string) => void) => void;
  signout: (callback: () => void) => void;
  refreshUser: (callback: (user: User) => void) => void;
  isAdmin: boolean;
}
export const AuthContext = createContext<AuthContextInterface | null>(null);
export const useAuth = () => useContext(AuthContext);
